export const multivendor = {
	closings: {
		title: "Closing by vendor",
		filename: "closing-by-vendor",
		columns: {
			vendorName: "Vendor",
			vendorValueToReceive: "Amount receivable",
			otherProductsFeeValue: "Variable fee on special products",
			generalFeeValue: "General variable fee",
			eventDate: "Event date",
			payDate: "Pay date",
			generalPercentageFee: "Variable fee on billing",
			fixedFee: "Fixed rental fee",
			totalSoldValue: "Total billing",
		},
		emptyText: "No data to display.",
	},
	productsSold: {
		title: "Products sold by vendor",
	},
	revenues: {
		title: "Billing by vendor",
		description: "Multivendor reports of each vendor",
		filename: "billing_by_vendor",
		columns: {
			name: "Vendor",
			totalSoldValue: "Products sold",
			totalTipValue: "Service",
			subtotal: "Subtotal",
			rent: "Rent",
			revenue: "Revenue",
			singleProductReturns: "Single product returns",
		},
	},
};
